import React, { useContext, useState } from "react";
import { Modal, Button } from "antd";
import Results from "./results";

import { EmissionContext } from "../../emission";
import Vehicle from "./vehicle";
import Senario from "./senario";

export default function ModalComponent({ embed }) {
  const { filterData, setFilterData } = useContext(EmissionContext);
  const [disable, setDisable] = useState(true);
  const [Filters, setFilters] = useState({
    scenarios: [],
    technologies: [],
    sheet: "",
  });

  const [ModalVisible, setModalVisible] = useState(embed);

  const [currentKey, setCurrentKey] = useState(1);

  const onFinish = () => {
    setFilterData({ ...filterData, ...Filters });
    setModalVisible(false);
  };

  return (
    <Modal
      visible={ModalVisible}
      footer={false}
      width={1000}
      centered
      title={false}
      className="embed-modal"
    >
      <div className="py-12 relative">
        {currentKey === 1 && (
          <Results
            onSelect={(val) => {
              setDisable(false);
              setFilters({ ...Filters, sheet: val });
            }}
          />
        )}
        {currentKey === 2 && (
          <Vehicle
            onSelect={(val) => {
              val.length === 0 ? setDisable(true) : setDisable(false);
              setFilters({ ...Filters, technologies: val });
            }}
          />
        )}

        {currentKey === 3 && (
          <Senario
            onSelect={(val) => {
              val.length === 0 ? setDisable(true) : setDisable(false);
              setFilters({ ...Filters, scenarios: val });
            }}
          />
        )}
      </div>
      <div className="flex justify-center items-center">
        {currentKey === 3 ? (
          <Button
            type="secondary"
            className="rounded-full w-80 disabled:opacity-0 h-10"
            disabled={disable}
            onClick={() => {
              onFinish();
            }}
          >
            Finish
          </Button>
        ) : (
          <Button
            type="secondary"
            className="rounded-full w-80 disabled:opacity-0 h-10"
            disabled={disable}
            onClick={() => {
              setCurrentKey(currentKey + 1);
              setDisable(true);
            }}
          >
            Next
          </Button>
        )}
      </div>
    </Modal>
  );
}
